import gql from 'graphql-tag';

export default gql`
  query ValidateImportOrders($input: ValidateImportOrdersInput!) {
    validateImportOrders(input: $input) {
      success
      message
    }
  }
`;
